import React from 'react';
import {Link} from 'react-router-dom';
import {Body} from '@lightricks/react-design-system';
import type {PostRequirement} from '../../postRequirements';
import styles from './PostRequirementRow.module.scss';

const ICON_BY_KEY: Record<PostRequirement['key'], React.ReactNode> = {
  'feed-posts': (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={22}
      height={22}
    >
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" />
    </svg>
  ),
  'reels': (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={22}
      height={22}
    >
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <path d="M9 9l6 3-6 3z" fill="currentColor" stroke="none" />
    </svg>
  ),
  'stories': (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={22}
      height={22}
    >
      <circle cx="12" cy="12" r="9" strokeDasharray="3 3" />
    </svg>
  ),
};

interface Props {
  req: PostRequirement;
}

export default function PostRequirementRow({req}: Props) {
  return (
    <div
      className={`${styles.postRow} ${req.done ? '' : styles.postRowRequired}`}
      data-testid="post-req-row"
      data-key={req.key}
      data-done={req.done}
    >
      <div className={styles.icon} aria-hidden>
        {ICON_BY_KEY[req.key]}
      </div>
      <div className={styles.main}>
        <Body size="sm" className={styles.label}>
          {req.label}
        </Body>
        <div className={styles.meta}>
          <span
            className={`${styles.pill} ${
              req.done ? styles.pillDone : styles.pillRequired
            }`}
            data-testid="post-req-pill"
          >
            {req.done ? 'Done' : 'Required'}
          </span>
          <Body
            size="xs"
            className={styles.count}
          >{`${req.accepted} of ${req.required} posted`}</Body>
        </div>
      </div>
      <Link
        to={req.to}
        className={styles.gotoLink}
        data-testid="post-req-goto"
        aria-label={`Go to ${req.label}`}
      >
        Go to ›
      </Link>
    </div>
  );
}
